<style src="./TaskStatus.scss" lang="scss" scoped></style>
<template>
  <div
    v-show="!!(status && status.status) || resultTotal"
    class="task-status">
    <span
      v-if="!(status && status.meta)"
      class="status">
      {{ status && status.status | translate }}
    </span>

    <span
      v-if="status && status.meta && status.meta.metaStatus && !status.meta.returnDate"
      :title="status.meta.metaStatus"
      class="status">
      <icon-danger class="icon-danger"/>
      {{ status.meta.metaStatus }}
    </span>

    <span
      v-if="status && status.meta && status.meta.returnDate"
      :title="`${status.meta.metaStatus}: ${formattedDate(status.meta.returnDate)}`"
      class="status">
      <icon-calendar class="icon-calendar"/>
      {{ status.meta.returnDate | dateBR }}
    </span>

    <span
      v-if="resultTotal > 0"
      :title="status.meta.distributorName"
      class="status">
      <small>R$</small> {{ resultTotal | CurrencyBR }}
    </span>
    <span
      v-if="resultTotal === 0"
      :title="status.meta.distributorName"
      class="status__lostallitems">
      PERDEMOS
    </span>
  </div>
</template>

<script>
import { CurrencyBR, DateBR, FriendlyVerboseWeeklyDateTime } from '@/components/primitives/helpers/filters'
import { IconDanger, IconCalendar } from '@/components/primitives/icons'

// const RETURN_WHEN = 'RETORNA-EM'
// const NORMAL_STATUS = 'NORMAL-STATUS'

export default {
  name: 'TaskStatus',
  components: {
    IconDanger,
    IconCalendar
  },
  props: {
    status: {
      default: null
    },
    event: {
      default: null
    }
  },
  filters: {
    translate (v) {
      if (v === 'APPROVED') {
        return 'APROVADO'
      }
      return v
    },
    CurrencyBR,
    DateBR
  },
  data: () => ({
    resultTotal: false
  }),
  mounted () {
    this.sumResultTotal()
  },
  methods: {
    formattedDate (date) {
      return FriendlyVerboseWeeklyDateTime(date)
    },
    sumResultTotal () {
      // Case Result
      if (this.status.meta && this.status.meta.hasOwnProperty('distributorId')) {
        const defaultDistributors = this.$store.getters['Distributors/DEFAULT_DISTRIBUTOR_ID']
        const distributors = this.event.result.distributors.filter(d => defaultDistributors.includes(d.distributor.toString()))
        const sum = distributors.reduce((acc, dist) => acc + dist.total, 0)
        this.resultTotal = sum
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/board/components/task-status/TaskStatus.vue